import { action, computed, makeObservable, observable } from 'mobx';
import { MultiSelectViewModel } from 'shared/components';
import { AsyncState } from 'shared/libs/state';
import { JobCategory } from 'jobs/types';
import { v4 as uuidv4 } from 'uuid';

export type DesiredSubCategory = JobCategory;

export class DesiredCategoryGroup {
  readonly id = uuidv4();
  categoryId = '';
  readonly loadSubCategoriesState = new AsyncState<DesiredSubCategory[]>();
  readonly options = observable.array<DesiredSubCategory>([]);
  readonly specializations = new MultiSelectViewModel<DesiredSubCategory>([], {
    maxSelected: 2,
    getLabel: (value) => value.name,
  });

  constructor(categoryId = '') {
    makeObservable(this, {
      categoryId: observable,
      isLoading: computed,
      options: observable,
      valid: computed,
      filteredOptions: computed,
      setCategoryId: action.bound,
      setOptions: action.bound,
      setSelected: action.bound,
      clearSpecializations: action.bound,
    });

    this.categoryId = categoryId;
  }

  get valid(): boolean {
    return Boolean(this.categoryId && this.specializations.values.length > 0);
  }

  get isLoading(): boolean {
    return this.loadSubCategoriesState.status === 'pending';
  }

  get filteredOptions(): DesiredSubCategory[] {
    const query = this.specializations.search.trim().toLowerCase();
    if (!query) {
      return this.options.slice();
    }

    return this.options.filter((option) =>
      option.name.toLowerCase().includes(query)
    );
  }

  setCategoryId(value: string): void {
    this.categoryId = value;
  }

  setOptions(values: DesiredSubCategory[]): void {
    this.options.replace(values);
  }

  setSelected(values: DesiredSubCategory[]): void {
    this.specializations.values.replace(values);
  }

  clearSpecializations(): void {
    this.specializations.clear();
  }
}
